import React, { useState } from "react";
import { RiCheckLine, RiTrophyLine, RiArrowRightLine } from "react-icons/ri";

const VISIBLE_COUNT = 4;

const PostExerciseList = ({ exercises }) => {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? exercises : exercises.slice(0, VISIBLE_COUNT);
  const hasMore = exercises.length > VISIBLE_COUNT;

  return (
    <div className="wpc-exercises">
      {visible.map((ex) => {
        const hasPR = ex.sets.some((s) => s.isPR);
        return (
          <div className="wpc-exercise" key={ex.name}>
            <div className="wpc-exercise-name">
              <RiCheckLine size={15} className="wpc-exercise-check" />
              {ex.name}
            </div>
            <div className="wpc-exercise-sets">
              {ex.sets.map((set, i) => (
                <span className="wpc-set-chip" key={i}>
                  {set.weight} × {set.reps}
                </span>
              ))}
              {hasPR && (
                <span className="wpc-pr-badge">
                  <RiTrophyLine size={12} /> New PR
                </span>
              )}
            </div>
          </div>
        );
      })}

      {hasMore && !expanded && (
        <button
          type="button"
          className="wpc-view-full"
          onClick={() => setExpanded(true)}
        >
          View Full Workout <RiArrowRightLine size={14} />
        </button>
      )}
    </div>
  );
};

export default PostExerciseList;
